import { Title as titleKey } from './pre'
import { planTypes } from '@/common/constants';
export default {
  name: 'AdditionalCoEditor',
  data() {
    return {
      description: this.$t('billing.events.addon.co_editors_desc'),
      desc: this.$t('billing.events.addon.co_editors_attendees_desc'),
      title: this.$t(titleKey),
      logo: require('@/assets/plans/additional-co-editor.svg'),
      planType: planTypes.ADDITIONAL_CO_EDITOR
    };
  },
};
